import { action, observable } from 'mobx'

export class UserStore {
  @observable currentUser = null
  @observable userList = null

  @action setCurrentUser = (user) => {
    this.currentUser = user
  }

  @action setUserList = (users) => {
    this.userList = users
  }
}
